import { render, staticRenderFns } from "./PayCreateAccountTransfer.vue?vue&type=template&id=c1fa1a12"
import script from "./PayCreateAccountTransfer.vue?vue&type=script&lang=js"
export * from "./PayCreateAccountTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports